import { ExperienceProofEmployment } from "./experienceProof";

export const experienceProofEmploymentI18n: Record<
  ExperienceProofEmployment,
  {
    title: string;
    subTitle?: string;
    group?: string;
  }
> = {
  [ExperienceProofEmployment.JobOffer]: {
    title: "application:experience.field.proof.job_offer",
    group: "application:experience.field.proof.proof_fact_group",
  },
  [ExperienceProofEmployment.EmploymentContract]: {
    title: "application:experience.field.proof.employment_contract",
    group: "application:experience.field.proof.proof_fact_group",
  },
  [ExperienceProofEmployment.EmploymentLetters]: {
    title: "application:experience.field.proof.employment_letters",
    subTitle: "application:experience.field.proof.employment_letters_subtitle",
    group: "application:experience.field.proof.proof_fact_group",
  },
  [ExperienceProofEmployment.TaxReport]: {
    title: "application:experience.field.proof.tax_report",
    group: "application:experience.field.proof.proof_fact_group",
  },
  [ExperienceProofEmployment.ProofCompensation]: {
    title: "application:experience.field.proof.proof_compensation",
    group: "application:experience.field.proof.proof_fact_group",
    subTitle: "application:experience.field.proof.proof_compensation_subtitle",
  },
  [ExperienceProofEmployment.CompanyReports]: {
    title: "application:experience.field.proof.company_reports",
    group: "application:experience.field.proof.proof_success",
    subTitle: "application:experience.field.proof.company_reports_subtitle",
  },
  [ExperienceProofEmployment.PressReleases]: {
    title: "application:experience.field.proof.press_releases",
    group: "application:experience.field.proof.proof_success",
  },
  [ExperienceProofEmployment.FinancialTaxReports]: {
    title: "application:experience.field.proof.financial_tax_reports",
    group: "application:experience.field.proof.proof_success",
    subTitle:
      "application:experience.field.proof.financial_tax_reports_subtitle",
  },
  [ExperienceProofEmployment.OtherReports]: {
    title: "application:experience.field.proof.other_reports",
    group: "application:experience.field.proof.proof_success",
    subTitle: "application:experience.field.proof.other_reports_subtitle",
  },
  [ExperienceProofEmployment.Messages]: {
    title: "application:experience.field.proof.messages",
    group: "application:experience.field.proof.proof_success",
    subTitle: "application:experience.field.proof.messages_subtitle",
  },
};
